
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import Services from '../../components/feature/Services';
import HowWeWork from '../../components/feature/HowWeWork';
import About from '../../components/feature/About';
import ContactForm from '../../components/feature/ContactForm';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <HowWeWork />
        <About />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
